import { render, staticRenderFns } from "./DeleteStripeLayout.vue?vue&type=template&id=c6052a74&%3AcurrentPeriodEndProp=Dot"
var script = {}
import style0 from "./DeleteStripeLayout.vue?vue&type=style&index=0&id=c6052a74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports